// src/components/Unauthorized.js
import React from 'react';
import '../styles/Unauthorized.css';

const Unauthorized = ({ errorMessage }) => {
    const handleRefresh = () => {
        window.location.reload(); // Refresh the browser
    };

    return (
        <div className="unauth-wrapper">
            {!errorMessage ? (
                <>
                    <h1>404 - Unauthorized Access</h1>
                    <p><p>The page you&apos;re looking for doesn&apos;t exist or you&apos;re not allowed here.</p>
                    </p>
                </>
            ) : (
                <>
                    <p className="error-message">{errorMessage}</p> 
                    <button className="refresh-button" onClick={handleRefresh}>
                    Please refresh the browser to reconnect.
                    </button>
                </>
            )}
        </div>
    );
};

export default Unauthorized;
